import React from 'react';
import Answer from '../../../components/answer/index.js';
import Directions from '../directions/index.js';
import Score from '../../../components/score';
import Breadcrumbs from '../../../components/breadcrumbs';

const Step = (props)=> {
  return (
	<div className="screen">
		<form className="actView fadeIn" onSubmit={props.formHandler}>
			<div className="question">
				<Directions />
				<h3 className="header3">03</h3>
				<h5 className="header5">Do you cough because of your asthma?</h5>
				<div className="faces">
					<Answer handler={props.answerHandler} id={props.name+"0"} set={props.name} value="0" state={props.state}>Yes, all of the time.</Answer>
					<Answer handler={props.answerHandler} id={props.name+"1"} set={props.name} value="1" state={props.state}>Yes, most of the time.</Answer>
					<Answer handler={props.answerHandler} id={props.name+"2"} set={props.name} value="2" state={props.state}>Yes, some of the time</Answer>		
					<Answer handler={props.answerHandler} id={props.name+"3"} set={props.name} value="3" state={props.state}>No, none of the time.</Answer>
				</div>
			</div>
			<button className="prev" type="button" onClick={props.prevHandler}>Back</button>
			<button className="next" type="submit" disabled>Next</button>
		</form>
		<Score Score={props.TempScore} Results={false} role={props.role} />
		<Breadcrumbs Step={props.step} Steps={props.steps-1} />
	</div>
	);
}

export default Step;
